import { data } from "autoprefixer";
import api from "../api";

export const getPayments = (data) => {
  return api.getApi().get(api.getBaseUrl() + "payments", {
    params: {
      page: data.page,
      pageSize: data.pageSize,
      nameFilter: data.nameFilter,
      invoiceIdFilter: data.invoiceIdFilter,
      countryFilter: data.countryFilter,
      yearFilter: data.yearFilter,
      typeFilter: data.typeFilter,
      relatedUserFilter: data.relatedUserFilter,
      sortColumn: data.sortColumn,
      sortDirection: data.sortDirection,
    },
  });
};
export const getPayment = (id) => {
  return api.getApi().get(api.getBaseUrl() + "payments/" + id);
};

// Odemenin proje yoneticisi iletisim bilgilerini gunceller
export const updatePayment = ({ id, data }) => {
  return api.getApi().put(api.getBaseUrl() + "payments/" + id, data);
};

export const getCommissions = (id, data) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "payments/" + id + "/commissions", {
      params: {
        page: data.page,
        pageSize: data.pageSize,
        nameFilter: data.nameFilter,
        emailNameFilter: data.emailNameFilter,
        statusFilter: data.statusFilter,
        lucaIdFilter: data.lucaIdFilter,
        sortColumn: data.sortColumn,
        sortDirection: data.sortDirection,
      },
    });
};
export const getCommission = (id, commissionId) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "payments/" + id + "/commissions/" + commissionId);
};

export const uploadPaymentWithExcel = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "payments/uploadExcel", data);
};

export const sendInvoiceMails = (id) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + "payments/" + id + "/send-invoice-mails");
};

export const sendReminderInvoiceMails = (data) => {
  return api
    .getApi()
    .post(
      api.getBaseUrl() +
        "payments/" +
        data.paymentId +
        "/send-reminder-invoice-mails",
      data.data
    );
};

export const getReminderMailPreview = (paymentId) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "payments/" + paymentId + "/reminder-mail-preview");
};
// Unauthorized request
export const getCommissionUploadDetail = (path) => {
  return api.getApiWithoutToken().get(api.getBaseUrl() + "invoice/" + path);
};

// Tekli mail gonderim ekraninda gosterilecek hazir metni getirir
export const getSingleInvoiceMailBody = ({ paymentId, commissionId }) => {
  return api
    .getApi()
    .get(
      api.getBaseUrl() +
        "payments/" +
        paymentId +
        "/commissions/" +
        commissionId +
        "/invoice-mail-body"
    );
};

export const sendSingleInvoiceMail = ({
  paymentId,
  commissionId,
  mailBodyMessage,
}) => {
  return api
    .getApi()
    .post(
      api.getBaseUrl() +
        "payments/" +
        paymentId +
        "/commissions/" +
        commissionId +
        "/send-invoice-mail",
      { mailBodyMessage }
    );
};

// istisna / gider pusulası akışı - fatura yüklemeden form gönderimi.
// data bir FormData'dir (istisna belgesi dosyasi da icerebilir).
export const postCommissionInvoiceForm = ({ path, invoiceId, data }) => {
  return api
    .getApiWithoutToken()
    .post(
      api.getBaseUrl() +
        "invoice/" +
        path +
        "/form?dir=exemptionDocs&paymentDir=" +
        (invoiceId || "default"),
      data
    );
};

export const postCommissionInvoiceUpload = (data) => {
  return api
    .getApiWithoutToken()
    .post(
      api.getBaseUrl() +
        "invoice/" +
        data.path +
        "/upload" +
        "?dir=paymentPdfs&paymentDir=" +
        data.invoiceId,
      data.data
    );
};
export const postCommissionInvoiceUploadManuel = (data) => {
  console.log(data);
  return api
    .getApiWithoutToken()
    .post(
      api.getBaseUrl() +
        "invoice/" +
        data.commissionId +
        "/uploadManuel" +
        "?dir=paymentPdfs&paymentDir=" +
        data.invoiceId,
      data.data
    );
};
export const downloadAllInvoices = async (id) => {
  return api
    .getApiForBlob()
    .get(api.getBaseUrl() + "payments/" + id + "/downloadAllInvoices");
};

export const calculatePayment = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "payments/calculate", data);
};
